import { useQuery } from "@tanstack/react-query";

import { chatApi } from "@/features/messaging/services/chat.api";

export function useConversation(chatId: string) {
  return useQuery({
    queryKey: ["conversation", chatId],
    queryFn: () => chatApi.getConversation(chatId),
    enabled: Boolean(chatId),
  });
}
